// IMPORT SERVICES
import { successRequest, failedRequest } from "../components/elementDatalayers";
import { trenzasService } from "../services/api";
import { loadUrlFile, setAndGetCookie } from "../utils/helpers";
const api = new trenzasService();

// IMPORT LIBRARIES
import * as Bouncer from "formbouncerjs";

Bouncer('#passionPointsBouncer', {
    disableSubmit: true,
    messages: {
        missingValue: {
            select: 'Por favor escoge una opción',
            default: "Este campo es obligatorio",
        }
    },
})

document.addEventListener('bouncerFormValid', function (event) {
    let nameQuestions = document.querySelectorAll('.trnz-passion__question') as NodeListOf<HTMLElement>
    let form = event.target as HTMLFormElement;
    let questions: Array<any> = [];
    let responses: Array<any> = [];
    new FormData(form).forEach((value) => responses.push(value));

    for (let i = 0; i < nameQuestions.length; i++) {
        questions.push({
            title: nameQuestions[i].innerText,
            response: responses[i]
        })
    }

    api.sendPassionPoint({ questions })
        .then((response: any) => response.json())
        .then((data: any) => {
            console.log(data);
            document.querySelector('#popupQuestions')?.classList.add('trnz-popup--hide')
            successRequest()
            loadUrlFile(setAndGetCookie('downloadFile'))
            setTimeout(() => {
                document.querySelector('#popupDownload')?.classList.remove('trnz-popup--hide')
            }, 200)
        })
        .catch((error: any) => {
            console.error('e:', error);
            failedRequest()
        })

}, false);
document.addEventListener('bouncerFormInvalid', () => {
    failedRequest()
})